export interface Service {
    id: string;
    name: string;
    description: string;
    duration: number;
    fees: number;
}

export enum AvailabilityStatus {
    BOOKED = "BOOKED",
    BLOCKED = "BLOCKED",
    AVAILABLE = "AVAILABLE",
    PAST = "PAST"
}

export interface Slot {
    id: number;
    start: string;
    end: string;
    status: AvailabilityStatus;
}

export interface TimeSlot {
    from: string;
    to: string;
}

export interface BlockedSlot {
    id: string;
    doctorId: string;
    date: string;
    blockedSlots: TimeSlot[];
    fullDayBlocked: boolean;
}

export enum AppointmentConfirmationStatus {
    SCHEDULED = "SCHEDULED",
    COMPLETE = "COMPLETE",
    CANCELLED = "CANCELLED",
    FORCE_RESCHEDULE = "FORCE_RESCHEDULE"
}

export interface IUser {
    id: string;
    name: string;
    phone: string;
    email: string;
}

export interface BaseAppointment {
    id: string;
    doctorId: string;
    startTime: string;
    endTime: string;
    type: {
        id: string;
        name: string;
        description: string;
        duration: number;
        fees: number;
    };
    status: AppointmentConfirmationStatus;
}

export interface Appointment extends BaseAppointment {
    userInfo: IUser;
}

export interface Address {
    addressLine1: string;
    city: string;
    state: string;
    country: string;
    pincode: string;
    street: string;
    addressLine2: string;
}

export interface IDoctor {
    id: string;
    name: string;
    email: string;
    phone: string;
    password?: string;
    profileImage?: string;
    clinicImage?: string;
    alias: string;
    speciality?: string;
    degree: string;
    designation?: string;
    clinicName: string;
    experience: number;
    about?: string;
    available: boolean;
    slots_booked: Record<string, any>;
    address: Address;
    date: number;
    website: string;
    hasUsedTrial: boolean;
    accessBundle: {
        features: string[];
        limits: Record<string, number | null>;
        featureMeta: Record<string, any>;
        version: number;
        updatedAt: Date | null;
    };
    tagline?: string;
    subheading?: string;
    publicPhone?: string;
    googleMapsLink?: string;
}
